import React from 'react';
import { Blog as SharedBlog } from '@akyga/shared-ui/Blog';
import Main from 'layouts/Main';
import Container from 'components/Container';
import cmsClient from 'API/cmsClient';

function Blog() {
  return (
    <Main>
      <Container>
        <SharedBlog cmsClient={cmsClient} pageNameFilter={['components', 'both']} />
      </Container>
    </Main>
  );
}

export default Blog;
